import { ACTION_COLUMN_WIDTH } from "./HyroTable.consts";
import { gridExpandedSortedRowIdsSelector, gridVisibleColumnDefinitionsSelector } from "@mui/x-data-grid";

export const numericNullsLastComparator = (a, b) => {
  if (a == null && b == null) return 0;
  if (a == null) return 1;
  if (b == null) return -1;
  return a - b;
};

// DataGrid sortComparator that keeps the row with `pinnedRowId` on top under both asc and desc sort.
export const pinRowToTop = (pinnedRowId, comparator = numericNullsLastComparator) => (v1, v2, p1, p2) => {
  const firstPinned = p1.id === pinnedRowId;
  const secondPinned = p2.id === pinnedRowId;
  if (firstPinned && secondPinned) return 0;
  if (!firstPinned && !secondPinned) return comparator(v1, v2, p1, p2);

  const direction = p1.api?.getSortModel?.()?.find((s) => s.field === p1.field)?.sort ?? "asc";
  return (firstPinned ? -1 : 1) * (direction === "desc" ? -1 : 1);
};

export const isCellInViewport = (apiRef, id, field) => {
  const cell = apiRef.current.getCellElement(id, field);
  if (!cell) return false;

  const rect = cell.getBoundingClientRect();
  const gridRect = apiRef.current.rootElementRef?.current?.getBoundingClientRect();
  if (!gridRect) return false;

  // Account for the sticky actions column by reducing the effective right boundary
  const effectiveRight = gridRect.right - ACTION_COLUMN_WIDTH;

  return (
    rect.top >= gridRect.top &&
        rect.bottom <= gridRect.bottom &&
        rect.left >= gridRect.left &&
        rect.right <= effectiveRight
  );
};

export const focusCell = (apiRef, id, field) => {
  const rowIndex = gridExpandedSortedRowIdsSelector(apiRef).findIndex((id) => id === id);
  const colIndex = gridVisibleColumnDefinitionsSelector(apiRef).findIndex((column) => column.field === field);
  if (rowIndex === -1 || colIndex === -1 || isCellInViewport(apiRef, id, field)) {
    return;
  }
  apiRef.current.scrollToIndexes({ rowIndex, colIndex });

  setTimeout(() => {
    // If cell is still not in viewport after basic scroll, it's likely hidden behind actions column
    if (!isCellInViewport(apiRef, id, field)) {
      const cell = apiRef.current.getCellElement(id, field);
      const gridRect = apiRef.current.rootElementRef?.current?.getBoundingClientRect();

      if (cell && gridRect) {
        const cellRect = cell.getBoundingClientRect();
        const actionsColumnStart = gridRect.right - ACTION_COLUMN_WIDTH;
        const overlapWidth = cellRect.right - actionsColumnStart;

        const currentPosition = apiRef.current.getScrollPosition();
        apiRef.current.scroll({
          left: currentPosition.left + overlapWidth + 10, // +10 for some padding
          top: currentPosition.top
        });
      }
    }

    apiRef.current.setCellFocus(id, field);
  }, 50);

};
